import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { Marker, useMap } from "react-map-gl/maplibre";

import { Link } from "@/components/link";
import { useGmwGeojsonQuery } from "@/queries/query-gmw";

import { useGmwContext } from "../../../contexts/gmw-context";
import { gmwInformation } from "../../../types";

const MapMarker: React.FC = () => {
  const { selectedGmw, setSelectedGmw } = useGmwContext();
  const { data } = useGmwGeojsonQuery();
  const map = useMap().current;

  const selectedLocation = useMemo(
    () =>
      data?.features.find((feature) => feature.properties.uuid === selectedGmw?.uuid)?.geometry
        .coordinates,
    [data, selectedGmw]
  );

  useEffect(() => {
    const deSelect = () => setSelectedGmw(undefined);

    if (selectedGmw) map?.on("click", deSelect);
    return () => {
      map?.off("click", deSelect);
    };
  }, [map, selectedGmw, setSelectedGmw]);

  if (!selectedGmw || !selectedLocation) return null;

  return (
    <Marker longitude={selectedLocation[0]} latitude={selectedLocation[1]} anchor="bottom">
      <Flex
        flexDirection="column"
        alignItems="center"
        cursor="default"
        onClickCapture={(e) => {
          e.stopPropagation();
        }}
      >
        <Box bg="white" p="5">
          {gmwInformation.map(({ key, label }) => {
            return (
              <Text key={label}>
                {label}: {selectedGmw[key]}
              </Text>
            );
          })}

          <Link inline to={`/gmw/constructie/${selectedGmw.uuid}/`}>
            <Button
              variant="outlinePrimary"
              mx="0"
              mt="4"
              fontSize="sm"
              p="1"
              fontWeight={400}
              h={8}
            >
              Detail pagina
            </Button>
          </Link>
        </Box>
        <Box
          transform="translateY(-1px)"
          clipPath="polygon(100% 0, 0 0, 50% 100%)"
          w="5"
          h="5"
          bg="white"
        ></Box>
      </Flex>
    </Marker>
  );
};

export { MapMarker };
